<template>
  <div class="home-page">
    <div class="select-wrapper">
      <!-- logo row -->
      <div class="logo-row">
        <div class="logo-combo" aria-label="app logos">
          <img class="logo-combo-bg"  src="/static/images/select_page/select_logo_bg.png" alt="logo background">
          <div class="logo-combo-icons"><img class="logo-combo-icon" src="/static/images/select_page/select_chineasy_logo.png" alt="Chineasy logo">
          <img class="logo-combo-icon" src="/static/images/select_page/select_japaneasy_logo.png" alt="Japaneasy logo">
          </div>
        </div>
      </div>

      <!-- title -->
      <div class="title-section">
        <img
          class="title-main"
          :src="isEnglish ? '/static/images/select_page/select_choose_en.png' : '/static/images/select_page/select_choose_mm.png'"
          alt="Choose language"
        >
        <img
          class="title-sub"
          :src="isEnglish ? '/static/images/select_page/select_title_en.png' : '/static/images/select_page/select_title_mm.png'"
          alt="Subtitle"
        >
      </div>

      <!-- language cards -->
      <div class="cards-section">
        <div class="language-card language-card--left" @click="selectLang('chinese')">
          <img
            class="language-image"
            :src="isEnglish ? '/static/images/select_page/select_chinese_en.png' : '/static/images/select_page/select_chinese_mm.png'"
            alt="Chinese option"
          >
          <div v-if="selectedLang === 'chinese'" class="selected-tag" aria-label="selected">
            <img
              class="selected-tag-img"
              src="/static/images/select_page/select_selected.png"
              alt="selected"
            >
            <span class="selected-tag-text">{{ $t('Selected') }}</span>
          </div>
        </div>
        <div class="language-card language-card--right" @click="selectLang('japanese')">
          <img
            class="language-image"
            :src="isEnglish ? '/static/images/select_page/select_japanese_en.png' : '/static/images/select_page/select_japanese_mm.png'"
            alt="Japanese option"
          >
          <div v-if="selectedLang === 'japanese'" class="selected-tag" aria-label="selected">
            <img
              class="selected-tag-img"
              src="/static/images/select_page/select_selected.png"
              alt="selected"
            >
            <span class="selected-tag-text"> {{ $t('Selected') }}</span>
          </div>
        </div>
      </div>

      <!-- tip text -->
      <p class="pick-tip">
        {{ $t('select_pick_tip') }}
      </p>

      <!-- start button -->
      <div class="start-section" @click="startLearning()">
        <img
          class="start-button"
          :src="isEnglish ? '/static/images/select_page/select_start_learning_en.png' : '/static/images/select_page/select_start_learning_mm.png'"
          alt="Start learning"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isEN: 'bur',
      selectedLang: 'chinese'
    }
  },
  computed: {
    isEnglish() {
      return this.isEN === 'en'
    }
  },
  created() {
    this.isEN = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'bur'
    // this.selectedLang = localStorage.getItem('select_lang') ? localStorage.getItem('select_lang') : 'chinese'
  },
  methods: {
    selectLang(lang) {
      this.selectedLang = lang
    },
    startLearning() {
      let that = this;
      // localStorage.setItem('select_lang', this.selectedLang)
      that.$parent.loadModal(true);
      that.$api.post('/api/index/select_lang', {'lang': this.selectedLang}, r => {
        that.$parent.returnCode(r, function () {
          if (that.selectedLang == "chinese") {
            that.$router.push({path: '/'});
          } else {
            const mobile = localStorage.getItem('mobile')
            window.location.href =  that.$japUrl+'?mobile=' + mobile;
          }
        });
      })
    }
  }
}
</script>

<style scoped>
.home-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.select-wrapper {
  width: 100%;
  max-width: 640px;
  min-height: 100vh;
  padding: 36px 24px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.logo-row {
  display: flex;
  justify-content: center;
  margin-bottom: 34px;
}

.logo-combo {
  position: relative;
  width: clamp(290px, 52vw, 260px);
  height: clamp(130px, 16vw, 90px);
}

.logo-combo-bg {
  width: 100%;
  height: 100%;
  display: block;
}

.logo-combo-icons {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(10px, 2.6vw, 14px);
}

.logo-combo-icon {
  width: clamp(120px, 16vw, 92px);
  height: auto;
  display: block;
}

.logo-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 72%;
  max-height: 72%;
}

.title-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 38px;
}

.title-main {
  width: 120%;

  margin-bottom: 20px;
}

.title-sub {
  width: 100%;

}

.cards-section {
  display: flex;
  justify-content: center;
  gap: clamp(18px, 4vw, 32px);
  margin-bottom: 24px;
}

.language-card {
  position: relative;
  flex: 1;
  max-width: clamp(230px, 46vw, 300px);
}

.language-image {
  width: 100%;
  display: block;
}

.selected-tag {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  width: clamp(110px, 62%, 170px);
  pointer-events: none;
}

.selected-tag-img {
  width: 100%;
  display: block;
}

.selected-tag-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 21px;
  letter-spacing: 0.5px;
  color: #ffffff;
  -webkit-text-stroke: 1px #000000;
  text-stroke: 1px #000000;
}

.pick-tip {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #7a3900;
  margin: 8px 0 20px;
}

.start-section {
  margin-top: 0;
  display: flex;
  justify-content: center;
}

.start-button {
  width: 100%;
  max-width: clamp(340px, 80vw, 420px);
}

@media (max-width: 360px) {
  .select-wrapper {
    padding: 30px 16px 30px;
  }

  .cards-section {
    gap: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/select.vue